import { useMutation } from "react-query";
import API from "../../Config/axios";

const onEndShiftSession = async (payload) => {
  const { data } = await API.post("queues/endShiftSession", payload);
  return data;
};

const useEndShiftSession = () => {
  return useMutation((payload) => onEndShiftSession(payload));
};

export default useEndShiftSession;
